import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Dishes from './components/Dishes';
import UserProfile from './components/UserProfile';
import RecipeCard from './components/RecipeCard';
import LogInForm from './components/LogInForm'; // Make sure this matches the file name
import CalorieTracker from './components/CalorieTracker';
import './App.css';

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Dishes />} />
        <Route path="/user-profile" element={<UserProfile />} />
        <Route path="/recipe-card" element={<RecipeCard />} />
        <Route path="/login" element={<LogInForm />} />
        <Route path="/calorie-tracker" element={<CalorieTracker />} />
      </Routes>
    </Router>
  );
}

export default App;
